import React, { useEffect, useState } from "react";
import "./Home.css";
import Testimonial from "../components/Testimonial";
import FAQ from "../components/FAQ";
import { getBanners, getIntro, getWhyChoose, getInfoCards, getVanityImages } from "../services/homeService";

const Home = () => {
  const [banners, setBanners] = useState([]);
  const [current, setCurrent] = useState(0);
  const [intro, setIntro] = useState({ heading: "", paragraph: "" });
  const [whyChoose, setWhyChoose] = useState({ image: "", points: [] });
  const [infoCards, setInfoCards] = useState([]);
  const [smallCards, setSmallCards] = useState([]);
  const [touchStartX, setTouchStartX] = useState(null);

  useEffect(() => {
    getBanners().then(setBanners);
    getIntro().then(setIntro);
    getWhyChoose().then(setWhyChoose);
    getInfoCards().then(setInfoCards);
    getVanityImages().then(setSmallCards);
  }, []);

  const handleTouchStart = (e) => {
    setTouchStartX(e.touches[0].clientX);
  };

  const handleTouchEnd = (e) => {
    const touchEndX = e.changedTouches[0].clientX;
    const diff = touchStartX - touchEndX;
    if (diff > 50) {
      goToSlide((current + 1) % banners.length);
    } else if (diff < -50) {
      goToSlide((current - 1 + banners.length) % banners.length);
    }
  };

  // Auto Slide Logic
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % banners.length);
    }, 3000);
    return () => clearInterval(timer);
  }, [banners]);
const goToSlide = (index) => {
  setCurrent(index);
};
  return (
    <div className="home-page">
      {/* Section 1: Banner Slider */}
      <section className="banner-slider" onTouchStart={(e) => handleTouchStart(e)}
  onTouchEnd={(e) => handleTouchEnd(e)}>
        {banners.length > 0 && (
          <a href={banners[current]?.Link} target="_blank" rel="noreferrer">
            <img src={banners[current]?.Image} alt={`banner-${current}`} className="banner-img" />
          </a>
        )}
        <button className="prev-btn" onClick={() => goToSlide((current - 1 + banners.length) % banners.length)}>❮</button>
<button className="next-btn" onClick={() => goToSlide((current + 1) % banners.length)}>❯</button>

      </section>

      {/* Section 2: Brand Intro */}
      <section className="brand-intro fade-in">
        <h2 className="slide-left text-center">{intro.heading}</h2>
        <p className="slide-right text-center">{intro.paragraph}</p>
      </section>

      

      {/* Section 4: Info Cards */}
      <div className="service-head"><h2 >Step inside our world of Makeup Artistry</h2></div>
      <section className="info-cards fade-in">
        
        {infoCards.map((card, i) => (
          <div key={i} className="info-card slide-right" onClick={() => window.open(card.link, '_blank')}>
            <img src={card.img} alt={card.title} />
            <h3>{card.title}</h3>
            <p>{card.desc}</p>
          </div>
        ))}
      </section>

      {/* Section 5: Small Cards Slider */}
      <section className="small-card-slider fade-in">
        <h2>Insight to our vanity</h2>
        <div className="scroll-row">
          {smallCards.map((img, i) => (
            <img key={i} src={img} alt={`mini-${i}`} className="small-card slide-up" />
          ))}
        </div>
      </section>

      <Testimonial />

      {/* Section 3: Why Choose Us */}
      <section className="why-choose fade-in">
        <div className="why-text slide-left">
          <h2>What Makes us Different</h2>
          <ul>
            {whyChoose.points.map((point, i) => <li key={i}>{point}</li>)}
          </ul>
        </div>
        <div className="why-image slide-right">
          <img src={whyChoose.image} alt="Why Choose Us" />
        </div>
      </section>
      
      <FAQ />
    </div>
  );
};

export default Home;
